import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationResponse, UserInfo } from 'src/app/models';
import { UserService, NotificationService, ObservableService, ToastService, WorkspaceService } from 'src/app/services';
import { NotificationsModalComponent } from 'src/app/components';
import { Subscription, Observable, fromEvent } from 'rxjs';
import { MsalService } from 'src/app/services/msal.service';
import { SearchBarEntityResponse, SearchBarResponse } from '../../models/workspaces.models';
import { distinctUntilChanged, debounceTime, switchMap, map, filter } from 'rxjs/operators';
import { getToolIcon } from 'src/app/resources/tool-utils';


@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
export class TopbarComponent implements OnInit, OnDestroy {

  user: UserInfo;
  topWrapper: number;
  notification: NotificationResponse;
  notificationsSubscribe: Subscription;
  entityList: SearchBarResponse[];
  searchValue = false;
  getIcon = getToolIcon;
  @ViewChild("searchBarInput", { static: true }) searchBarInput: ElementRef<HTMLInputElement>;

  constructor(
    private userService: UserService,
    private modalService: NgbModal,
    private notificationService: NotificationService,
    private observableService: ObservableService,
    private msalService: MsalService,
    private toastService: ToastService,
    private workspaceService: WorkspaceService) { }

  async ngOnInit() {
    try {
      this.user = await this.userService.getUserInfo();
        this.notification = await this.notificationService.getNotifications();
        // console.log(this.notification)
        if (this.searchBarInput) {
        fromEvent(this.searchBarInput.nativeElement, 'keyup')
        .pipe(
          // get value
          map((event) => {
            return (event.target as HTMLInputElement).value;
          }),
          // if character length greater then 2
            //filter((res: string) => {
            //    if (res.length >= 2) {
            //        return res.length >= 2;
            //    }
            //    else {
            //        this.searchValue = false;
            //    }
            //}),

          // Time in milliseconds between key events
          debounceTime(300),

          // If previous query is diffent from current
          //distinctUntilChanged()

          // subscription for response
        )
        .subscribe((text: string) => {
          this.getAvailableEntity(text);
        });

      }
    } catch (error) {
      // Wrong error response
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }

    /**
     * The observable is used to listen if a processed execution passes into Completed status
     * to update notifications list
     */

    this.observableService.notification.subscribe((data: boolean) => {
      if (data === undefined) { return; }
      this.user.new_notification = data;
    });

    this.notificationsSubscribe = this.observableService.updateNotificationsObs.subscribe(async (canUpdate: string) => {
      if (!canUpdate) { return; }

      if (canUpdate === 'updateNotifications') {
        this.notification = await this.notificationService.getNotifications();
        this.observableService.updateNotificationData();
      }
    });
  }

  /**
   * Opens the notification modal by clicking on the bell and sends the returned notifications
   */

  openNotificationsModal() {
    // console.log(this.notification)
    const modalRef = this.modalService.open(NotificationsModalComponent,
       { scrollable: true, windowClass: 'push-notification'});
    modalRef.componentInstance.data = {
      ...this.notification
    };
  }

  /**
   * User logout
   */

  logout() {
    this.msalService.logout();
  }

  ngOnDestroy() {
    if (this.notificationsSubscribe) {
      this.notificationsSubscribe.unsubscribe();
    }
    }

    async getAvailableEntity(searchValue: string) {
        if (searchValue === '') {
            this.entityList = [];
            this.closeSearchBar();
            return;
        }
        try {
            this.entityList = (await this.workspaceService.getSearchBarItems(searchValue)).searchBarResponseCategories;
            this.searchValue = true;
        } catch (error) {
            this.toastService.showError(error.error);
            console.error('error =>', error);
            this.entityList = [];
            this.closeSearchBar();
        }
    }

    clear() {
        this.searchBarInput.nativeElement.value = "";
        this.closeSearchBar();
    }

    closeSearchBar() {
        this.searchValue = false;
    }

    getEnteredValue(enteredValue: SearchBarEntityResponse) {
        this.searchBarInput.nativeElement.value = enteredValue.name;
        this.closeSearchBar();
    }
}
